import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Iconify from '../iconify';

const CustomDialog = ({ open, onClose, title, children, fullScreen }) =>
  fullScreen ? (
    <Dialog fullScreen open={open} onClose={onClose}>
      <AppBar position="relative" color="default">
        <Toolbar>
          <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
            {title}
          </Typography>
          <IconButton aria-label="delete" color="inherit" edge="start" onClick={onClose}>
            <Iconify icon="mingcute:close-line" />
          </IconButton>
        </Toolbar>
      </AppBar>

      {children}
    </Dialog>
  ) : (
    <Dialog open={open} onClose={onClose} fullWidth>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 3, py: 2, backgroundColor: 'background.paper' }}
      >
        <Typography variant="h6">{title}</Typography>
        <IconButton aria-label="delete" color="inherit" edge="start" onClick={onClose}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      </Stack>

      <Box sx={{ pt: 3, overflow: 'hidden' }}>{children}</Box>
    </Dialog>
  );

export default CustomDialog;

CustomDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  fullScreen: PropTypes.bool,
};
